<template>
    <!-- 上课禁用 -->
    <div class="mute-box">
        <div class="top-box">
            <el-button type="primary" @click='dialogClick'>新增</el-button>
        </div>
        <div class="Table-Bottom">
            <el-table
                :header-cell-style="{background:'#fff',color:'#000', height:'40px', }"
                ref="multipleTable"
                :data="tableData"
                :cell-style="{'text-align':'center'}"
                tooltip-effect="dark"
                @selection-change="handleSelectionChange">
                <el-table-column
                prop="address"
                label="时间段"
                show-overflow-tooltip>
                <template #default="scope">
                    <span v-for=" item in JSON.parse(scope.row.day)" :key="item" v-if="scope.row.day" >
                        <span v-if="item == 1"> {{ '周一'  }}, </span>
                        <span v-if="item == 2"> {{ '周二'  }}, </span>
                        <span v-if="item == 3"> {{ '周三'  }}, </span>
                        <span v-if="item == 4"> {{ '周四'  }}, </span>
                        <span v-if="item == 5"> {{ '周五'  }}, </span>
                        <span v-if="item == 6"> {{ '周六'  }}, </span>
                        <span v-if="item == 7"> {{ '周日'  }}, </span>
                    </span>
                    <span v-else>
                        {{ '永不' }}
                    </span>
                </template>
                </el-table-column>
                <el-table-column
                prop="address"
                label="开始时间"
                show-overflow-tooltip>
                <template #default="scope">
                    {{ scope.row.startTime }}
                </template>
                </el-table-column>
                <el-table-column
                prop="address"
                label="结束时间"
                show-overflow-tooltip>
                <template #default="scope">
                    {{ scope.row.endTime }}
                </template>
                </el-table-column>
                <el-table-column
                prop="address"
                label=""
                show-overflow-tooltip>
                <template #default="scope">
                    <!-- 00 -->
                    <el-switch v-model="scope.row.delivery" @change="onOffClick(scope.row)"></el-switch>
                </template>
                </el-table-column>
                <el-table-column
                prop="address"
                label="操作"
                show-overflow-tooltip>
                <template #default="scope">
                    <span @click="deleteClick(scope.row)" class="delete-title">删除</span>
                    <span @click="xiugaiClick(scope.row)" class="delete-xiugai">修改</span>
                </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- <el-button type="primary" class="bottom-but" @click="baocunclick">保存设置</el-button> -->
        <el-dialog
            v-model="dialogVisible"
            title="添加禁用"
            width="30%"
            :before-close="handleClose"
        >
            <div class="time-box">
                <el-form-item label="时段" label-width="60px">
                    <el-time-picker
                        is-range
                        v-model="value1"
                        range-separator="至"
                        :format="'HH:mm'"
                        value-format="HH:mm"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"
                        placeholder="选择时间范围">
                    </el-time-picker>
                </el-form-item>
            </div>
            <el-form-item label="" label-width="60px">
                <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
                    <el-checkbox v-for="city in cities" :label="city.value" :key="city.value">{{city.name}}</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
                
            <template #footer>
            <span class="dialog-footer">
                <el-button @click="handleClose">取消</el-button>
                <el-button type="primary" @click="confiemClise">
                确定
                </el-button>
            </span>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import { hiding,hidingadd,hidingUpdate,hidingdelete } from '@/assets/api/zhongduan.js'

export default {
    components: {

    },
    data() {
        return {
            tableData: [],
            dialogVisible: false,
            value1: [],
            cities: [ 
                {
                    name: '周一',
                    value:1
                },
                {
                    name: '周二',
                    value:2
                },
                {
                    name: '周三',
                    value:3
                },
                {
                    name: '周四',
                    value:4
                },
                {
                    name: '周五',
                    value:5
                },
                {
                    name: '周六',
                    value:6
                },
                {
                    name: '周日',
                    value:7
                },
            ],
            checkedCities: [],
            xiugaiObj:{}
        };
    },
    created() {
        this.hidingClick()
    },
    mounted() {

    },
    methods: {
        //修改
        xiugaiClick(item){
            console.log('我是修改',item);
            this.value1 = []
            this.xiugaiObj = item
            this.checkedCities = JSON.parse(item.day)
            this.value1.push(item.startTime)
            this.value1.push(item.endTime)
            this.dialogVisible = true
        },
        dialogClick () {
            this.dialogVisible = true
            this.value1= []
            this.checkedCities = []
            this.xiugaiObj = {}
        },
        // 查询
        hidingClick () {
            let params = {
                imei : this.$route.query.iemi,
            } 
            hiding(params).then((res)=> {
                console.log(res,'上课禁用列表');
                if ( res.data.data.length ) {
                    for ( let item of res.data.data ) {
                        if ( item.onOff == 1 ) {
                            item.delivery = true    
                        } else {
                            item.delivery = false    
                        }
                    }
                    this.tableData = res.data.data
                } else {
                    // console.log();
                    this.$message({
                        message: '暂无数据',
                        type: 'warning'
                    });
                }
            }).catch((err) => {
                this.$message({
                    type: 'error',
                    message: err.response.data.msg
                });
            })
        },
        onOffClick (item) {
            this.value1 = []
            this.xiugaiObj = item
            this.checkedCities = JSON.parse(item.day)
            this.value1.push(item.startTime)
            this.value1.push(item.endTime)
            this.switchClick(item)
        },
        //修改接口
        switchClick (item) {
            console.log(this.xiugaiObj,'修改');
            console.log(item);
            let params = {
                id: this.xiugaiObj.id,
                onOff: item.delivery? '1':'0',
                days: this.checkedCities,
                startTime: this.value1[0],
                endTime: this.value1[1],
            } 
            hidingUpdate(params).then((res)=> {
                this.$message({
                    message: '修改成功！',
                    type: 'success'
                });
                this.hidingClick()
                this.dialogVisible = false
            }).catch((err) => {
                this.$message({
                    type: 'error',
                    message: err.response.data.msg
                });
            })
        },
        //删除接口
        deleteClick (item) {
            let params = {
                id: item.id,
            } 
            hidingdelete(params).then((res)=> {
                this.$message({
                    message: '删除成功！',
                    type: 'success'
                });
                this.hidingClick()
            }).catch((err) => {
                // console.log(err);
                this.$message({
                    type: 'error',
                    message: err.response.data.msg
                });
            })
        },
        handleCheckedCitiesChange (value) {
            console.log(value,77899);
        },
        handleClose () {
            this.dialogVisible = false
        },
        confiemClise(){
            if ( JSON.stringify(this.xiugaiObj) != '{}') {
                this.switchClick(this.xiugaiObj)
            } else {
                this.addClose()
            }
        },
        // 新增
        addClose () {
            let params = {
                imei: this.$route.query.iemi,
                days: this.checkedCities,
                startTime: this.value1[0],
                endTime: this.value1[1],
                onOff: '1'
            } 
            hidingadd(params).then((res)=> {
                console.log(res,'上课禁用列表');
                this.$message({
                    message: '新增成功',
                    type: 'success'
                });
                this.hidingClick()
            }).catch((err) => {
                // console.log(err);
                this.$message({
                    type: 'error',
                    message: err.response.data.msg
                });
            })
            console.log('新增',this.value1);
            this.dialogVisible = false
        },
        // baocunclick () {
        //     var reDateTime = /^(?:(?:[0-2][0-3])|(?:[0-1][0-9])):[0-5][0-9]$/;
        //     for ( let item of this.tableData ) {
        //         if (item.value != '') {  
        //             if (reDateTime.test(item.value) != true) return  this.$message.error('闹钟格式有误！');
        //         }
        //     }
        //     console.log(this.tableData,'提交');
        // },
    },
};
</script>

<style scoped lang="scss">
.mute-box{
    background-color: #fff;
    .top-box {
        margin-top: 15px;
    }
    .Table-Bottom {
        width: 720px; /*no*/
        border: 1px solid  #eee;
        margin-top: 20px;
        
        :deep() {
            .el-input {
                width: 160px;
            }
            .el-table th.el-table__cell>.cell {
                text-align: center;
                font-size: 15px;
            }
        }
    }
    .bottom-but {
        margin: 20px 0px;
        margin-left: 130px;
    }
    .time-box {
        width: 80%;
    }
    .delete-title {
        color: red;
        cursor: pointer;
        margin-right: 5px;
    }
    .delete-xiugai{
        color: #459FFC;
    }
}
</style>
